import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { Session } from 'services';
import httpClient from 'utils/httpClient';

const CONFIRM_SESSION = (id: Number, courseId: Number) =>
  `/v2/teacher/course/${courseId}/session/${id}/teacher-confirm`;

export type ConfirmSessionBody = {
  id: Number;
  courseId: Number;
  isUnit: boolean;
};

export type ConfirmSessionResponse = {
  session: Session;
};

export const confirmSession = ({
  id,
  courseId,
  isUnit,
}: ConfirmSessionBody) => {
  let params = {};
  if (isUnit) {
    params = { confirm: 1, 'is-unit': isUnit };
  } else {
    params = { confirm: 1 };
  }
  return httpClient.post<ConfirmSessionResponse>(
    CONFIRM_SESSION(id, courseId),
    params,
  );
};

export const useConfirmSession = (
  opts?: UseMutationOptions<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    ConfirmSessionBody
  >,
) =>
  useMutation<
    AxiosResponse<ConfirmSessionResponse>,
    AxiosError<any>,
    ConfirmSessionBody
  >(confirmSession, opts);
